<template>
  <div>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2
        class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
      >
        Reset Password
      </h2>
    </div>
    <div v-show="showFail" class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-gray-900">
        It appears your password reset is invalid or has expired.
      </h2>
    </div>
    <div v-show="!showFail" class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <form @submit.prevent="resetPassword">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div>
            <WwpLabel>Password</WwpLabel>
            <div class="mt-1 rounded-md shadow-sm">
              <WwpInput v-model="password"></WwpInput>
            </div>
          </div>
          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <button
                class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              >
                Reset Password
              </button>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import WwpInput from "../ui/forms/BaseInput";
import WwpLabel from "../ui/forms/BaseLabel";

export default {
  name: "ResetPassword",
  components: {
    WwpLabel,
    WwpInput,
  },
  data() {
    return {
      password: "",
      showFail: false,
    };
  },
  methods: {
    resetPassword() {
      this.$store
        .dispatch("auth/reset_lost_password", {
          password: this.password,
          reset_password_token: this.$route.params.token,
        })
        .then(() => {
          this.$notify({
            title: "Lost Password",
            message: "Your password has been reset",
            type: "success",
          });
          this.$router.push("/login");
        });
    },
  },
  mounted() {
    const resp = this.$store.dispatch("auth/validate_lost_password", {
      reset_password_token: this.$route.params.token,
    });
    this.showFail = !!resp.success;
  },
};
</script>
